const NON_INTERNET_PRODUCT_TYPES_TO_SHOW = ["staticip", "voip"];
const CIS_LINK = "https://vost.ro/evergycis";

export {
  NON_INTERNET_PRODUCT_TYPES_TO_SHOW,
  CIS_LINK,
};
